import { FC, useState } from "react";
import { observer } from "mobx-react-lite";
import * as M from "moment";

import Constants from "../../../constants/Common";
import DefectCardItem from "./cardItem";
import DefectCardStatusItem from "./cardStatusItem";
import DefectUploadFiles from "./defectUploadFiles/defectUploadFiles";

import { EVENT_TYPE_PLANNING_ID } from "../../DefectForm/constants";

interface CardWaterSupplyProps {
  data: any;
  handleOpenPopupDefect: () => void;
}

const CardWaterSupply: FC<CardWaterSupplyProps> = observer(
  ({ data, handleOpenPopupDefect }) => {
    return (
      <>
        <DefectCardStatusItem
          label="Статус"
          value={data.incidentStatus?.title}
          handleOpenPopupDefect={handleOpenPopupDefect}
        />
        <DefectCardItem
          label="Комментарий к статусу"
          value={data.statusComment}
        />
        <DefectCardItem
          label={
            data.eventTypeId === EVENT_TYPE_PLANNING_ID
              ? "ID планового события"
              : "ID дефекта"
          }
          value={data.externalId}
        />
        <DefectCardItem label="Тип сети" value={data.gridType?.title} />
        <DefectCardItem label="Тип события" value={data.eventType?.title} />
        <DefectCardItem label="Организация" value={data.organization?.name} />
        <DefectCardItem
          label="Дата и время отключения/ограничения"
          value={
            data.dateTimeDisable
              ? M(data.dateTimeDisable).format(Constants.dateTimeFormat)
              : ""
          }
        />
        <DefectCardItem
          label={
            data.eventTypeId === EVENT_TYPE_PLANNING_ID
              ? "Дата и время завершения планового события"
              : "Дата и время устранения дефекта"
          }
          value={
            data.dateTimeEnable
              ? M(data.dateTimeEnable).format(Constants.dateTimeFormat)
              : ""
          }
        />
        <DefectCardItem
          label="ID объекта"
          value={data.objectShortName ? data.objectShortName : ""}
        />
        <DefectCardItem
          label="Административный район"
          value={data.district?.title}
        />
        <DefectCardItem
          label={
            data.eventTypeId === EVENT_TYPE_PLANNING_ID
              ? "Адрес планового события"
              : "Адрес дефекта"
          }
          value={data?.addressText}
        />
        <DefectCardItem label="Примечание к адресу" value={data?.addressNote} />
        <DefectCardItem
          label="Адреса отключ. зданий или с ограничениями по ЦО"
          value={data?.addressDisconnexionList
            ?.map((address) => address.text)
            .join("\n")}
        />
        <DefectCardItem
          label="Количество отключенных абонентов"
          value={data.disconnectedSubscribers}
        />
        <DefectCardItem
          label="Всего зданий в зоне отключения/ограничения"
          value={data.overBuildings}
        />
        <DefectCardItem
          label="Жилых зданий в зоне отключения/ограничения"
          value={data.livingBuildings}
        />

        <DefectCardItem
          label="Лечебных зданий в зоне отключения/ограничения"
          value={data.hospitalBuildings}
        />
        <DefectCardItem
          label="Детских зданий в зоне отключения/ограничения"
          value={data.childrenBuildings}
        />
        <DefectCardItem
          label="Прочих зданий в зоне отключения/ограничения"
          value={data.buildings}
        />
        <DefectCardItem label="Диаметр трубы (Ду), мм" value={data.diameter} />
        <DefectCardItem label="Тип прокладки" value={data.typeGasket?.title} />
        <DefectCardItem
          label="Вытекание"
          value={data.discharge ? "Да" : "Нет"}
        />
        <DefectCardItem
          label="Характер отключения"
          value={data.defNature?.title}
        />
        <DefectCardItem label="Статус" value={data.workStatus?.title} />
        <DefectCardItem label="Код жалобы" value={data.complaintCode?.title} />
        <DefectCardItem label="Категория" value={data.repairCategory?.title} />
        <DefectCardItem label="Ход работ" value={data.workProgress?.title} />
        <DefectCardItem
          label="Планируемая дата и время завершения работ"
          value={
            data.dateTimePlanned
              ? M(data.dateTimePlanned).format(Constants.dateTimeFormat)
              : ""
          }
        />
        <DefectCardItem
          label="Нормативное время, ч"
          value={data.standartTime}
        />
        <DefectCardItem label="Ответственный" value={data.responsible} />
        <DefectCardItem
          label="Телефон ответственного"
          value={data.responsiblePhone}
        />
        <DefectCardItem label="Комментарий" value={data.comment} />

        {data.files.length > 0 && <DefectUploadFiles data={data} />}
      </>
    );
  },
);

export default CardWaterSupply;
